import { transformAnalyticsToQueryParam } from '@atlassian/search-common';
import { addQueryParams, addQuery } from '../../../utils/url-utils';
import { useQuery } from '../../query-context';
export var useQueryParams = function useQueryParams() {
  var _useQuery = useQuery(),
    query = _useQuery.query;
  return function (url, searchSessionId, type, resultId, additionalAnalytics) {
    // legacy QF/QS have different types/have confluence prefixed or not
    return transformAnalyticsToQueryParam({
      query: query,
      url: url,
      searchSessionId: searchSessionId,
      additionalAnalytics: additionalAnalytics,
      resultId: resultId,
      type: type,
      addQueryParams: addQueryParams,
      addQuery: addQuery
    });
  };
};